import { z } from 'zod';
import { emailSchema } from '../../shared/email.schema';
import { DataSyncExcelDepartmentRowSchema, DataSyncExcelDownloadedIdsSchema, DataSyncExcelOrgFunctionRowSchema, DataSyncExcelPersonRowSchema, DataSyncExcelSystemRowSchema } from '../list-data-sync-excel-rows/list-data-sync-excel-rows.schema';
/** A sheet of the workbook, by the key of its list in the upload. */ export const DataSyncExcelSheetSchema = z.enum([
    'departments',
    'teams',
    'roles',
    'systems',
    'people'
]);
/**
 * The metadata of an upload refusal that names rows: the sheet, and the
 * 0-based indices of the offending rows in that sheet's request list.
 */ export const DataSyncExcelRefusalSchema = z.object({
    sheet: DataSyncExcelSheetSchema,
    indices: z.array(z.string())
});
const uploadUnit = {
    id: z.string().optional(),
    name: z.string().trim().min(1)
};
/**
 * POST /api/v2/data-sync/runs/excel: the lists of the uploaded
 * workbook in the download's shape, and the ids its download listed; a new
 * row has no id. Strict, so an attribute the sync does not need is
 * rejected, never read.
 */ export const StartExcelDataSyncRequestSchema = z.strictObject({
    departments: z.array(DataSyncExcelDepartmentRowSchema.extend({
        ...uploadUnit,
        lead: emailSchema().nullable()
    }).strict()),
    teams: z.array(DataSyncExcelOrgFunctionRowSchema.extend({
        ...uploadUnit,
        lead: emailSchema().nullable()
    }).strict()),
    roles: z.array(DataSyncExcelOrgFunctionRowSchema.extend({
        ...uploadUnit,
        lead: emailSchema().nullable()
    }).strict()),
    systems: z.array(DataSyncExcelSystemRowSchema.extend({
        ...uploadUnit,
        owner: emailSchema().nullable()
    }).strict()),
    people: z.array(DataSyncExcelPersonRowSchema.extend({
        id: z.string().optional(),
        email: emailSchema(),
        // Optional: an SPA loaded before the Standort column sends no location.
        location: z.string().trim().min(1).nullable().optional()
    }).strict()),
    /** Missing in a file that did not come from the download. */ downloaded: DataSyncExcelDownloadedIdsSchema.optional()
});

//# sourceMappingURL=start-excel-data-sync.schema.js.map